module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.ce04f81f.png";